import { cn } from "@/lib/utils";

export const HottestLaunchesBanner = () => {
	return (
		<div className="mb-2 grid gap-6 md:grid-cols-2">
			<h2
				className={cn(
					"relative text-3xl font-bold text-gray-700",
					"after:absolute after:-bottom-2 after:left-0 after:h-1 after:w-20 after:bg-blue-500 after:content-['']"
				)}
			>
				Hottest PropTech launches!
			</h2>

			<p className="text-lg text-gray-500">
				Witness the best new proptech products launching daily from across the globe and explore
				possibilities.
			</p>
		</div>
	);
};
